<style scoped>
p,
span {
  font-size: 1em !important;
}
</style>

<template>
  <div class="modal fade" tabindex="-1" role="dialog" ref='modal'>
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h3 class="modal-title" id="modalLabel"><strong>Terms and Conditions governing visitors and users of Inom.ph</strong></h3>
        </div>
        <div class="modal-body">
          <p>&nbsp;<br /> Please read these Terms and Conditions carefully before using the service.<br /> Users, visitors, and customers can only use the service through acceptance of and compliance with these Terms. By accessing, using, or taking part in the service of Inom.ph, you, the user, agrees to be bound by these Terms and Conditions. If you, the user, disagree with any of points within the Terms and Conditions then you are not allowed to use the service or may not avail of the service.</p>
          <p>&nbsp;</p>
          <p><span style="color: #ff0000;"><strong>Delivery and Processing Hours</strong></span></p>
          <p><span style="color: #ff0000;">All orders received before 1:30PM will be delivered the next day. All orders received after 1:30PM will be processed the next day and delivery will be the day after. Regulations governing delivery and processing might be subject to change without prior day notice for factors such as increment weather, and holidays.</span></p>
          <p>&nbsp;<br /> <strong>Purchases</strong><br /> Inom.ph may in some cases, depending on the need to verify the purchases, ask for certain information relevant to your purchase including, but not limited to, credit card number used, the name of the credit card holder, the expiration date of the credit card, valid ID, the billing address, and shipping information.</p>
          <p><br /> The user or customer accepts all responsibility and is accountable for the credit card used: (i) the user reserves the right to pay through any of the payment methods offered by Inom.ph; and that (ii) the payment details given or supplied by the user are correct and complete.</p>
          <p><br /> The user or customer, by submitting such information to Inom.ph, grants and entrusts Inom.ph the right to disclose said information to third parties strictly involved with the facilitation and delivery of goods to the user or customer.</p>
          <p>&nbsp;</p>
          <p>Inom.ph reserves the right to cancel or refuse orders at any time without prior notice, for reasons including but not limited to: inventory or service availability, typographical errors or human error on encoded price of product, fees, and/or service, glitches in the system that leads to misrepresentation of products of services, or other reasons.</p>
          <p>&nbsp;</p>
          <p>In an unlikely scenario that item/s purchased is unavailable for any reasons; an Inom.ph representative will suggest a substitute product. For a higher-costing substitute product, the price difference in cost between the substituted product and the replaced product has to be paid for prior to shipping. For a lower-costing substitute product, the price difference in cost between the replaced product and the substituted product will be converted to points that are utilized in Inom.ph. In the event that the customer or user does not want a substitute product, the cost of the unavailable product will be converted to points that are utilized in Inom.ph.</p>
          <p>&nbsp;</p>
          <p>If a replacement is not suitable, then the price of the unavailable item/s will be applied as store credit with a six (6) month expiration date. We reserve the right to refuse or cancel your order if fraud or an unauthorised or illegal transaction is suspected.</p>
          <p><strong>Availability, Errors and Inaccuracies</strong><br /> We are constantly updating our offerings of products and services on the Service. The products or services available on our Service may be mispriced, described inaccurately, or unavailable, and we may experience delays in updating information on the Service and in our advertising on other web sites.</p>
          <p><br /> We cannot and do not guarantee the accuracy or completeness of any information, including prices, product images, specifications, availability, and services. We reserve the right to change or update information and to correct errors, inaccuracies, or omissions at any time without prior notice.</p>
          <p>Contests, Sweepstakes and Promotions<br /> Any contests, sweepstakes or other promotions (collectively, "Promotions") made available through the Service</p>
          <p>&nbsp;</p>
          <p>&nbsp;</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
    <!-- <div class='modal.fade' tabindex="-1" role="dialog" aria-labelledby="modalLabel" ref='modal'>
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h5 class="modal-title" id="modalLabel"><strong>Terms and Conditions governing visitors and users of Inom.ph</strong></h5>
                </div>
                <div class="modal-body">
                    
                </div>
            </div>
        </div>
    </div> -->
</template>
<script>
import $ from 'jquery'
require('bootstrap')

export default {
  props: ['show'],
  data () {
    return {
      modal: null
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.modal.modal('show')
      } else {
        this.modal.modal('hide')
      }
    }
  },
  mounted () {
    this.modal = $(this.$refs.modal)
    this.modal.on('hide.bs.modal', () => {
      this.$emit('close')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-tac.vue